import { render, staticRenderFns } from "./ZhanhuiRankedByMj.vue?vue&type=template&id=2412d960&scoped=true"
import script from "./ZhanhuiRankedByMj.vue?vue&type=script&lang=js"
export * from "./ZhanhuiRankedByMj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412d960",
  null
  
)

export default component.exports